<template>
    <div>
        <div id="header">
            <div class="page-container" id="nav" style="background-color: #fff !important;">
                <div id="logo" class="logo"><a href="/" target="_self" title="首页"><img title="安泰商城"
                                                                                       src="../assets/img/logo.png"></a>
                </div>
                <!--<button type="button" class="navbar-toggle visible-xs-block js-show-menu" >-->
                <!--<i class="icon-menu"></i>-->
                <!--</button>-->
                <ul class="nav-item">
                    <li>
                        <a href="/" target="_self">首页</a>
                    </li>
                    <li>
                        <a href="/Course" target="_self">全部课程</a>
                    </li>
                    <!--<li><a href="javascript:void(0);" class="program-nav " target="_self">学员风采<i-->
                            <!--class="icn-new"></i></a>-->
                    <!--</li>-->
                    <li>
                        <a href="http://218.91.114.159:8888/zbat" target="_blank">学员端（新）<i
                                class="icn-new"></i></a>
                    </li>
                    <!--<li>-->
                        <!--<a href="http://47.104.157.125/Home/Index" target="_blank">学员端（旧）</a>-->
                    <!--</li>-->
                    <li><a href="http://zscx.zbat.com" class="program-nav " target="_blank">证书查询</a>
                    </li>
                    <li class="maxisshow"><a href="/Search" target="_self">搜索课程</a></li>
                    <!--<li><a href="/article"  target="_self">手记</a></li>-->

                </ul>
                <div id="login-area">
                    <ul class="header-unlogin clearfix">
                        <!--<li class="app-load" id="js-app-load">-->
                        <!--<a href="/mobile/app" target="_blank" style="width:60px;">下载APP</a>-->
                        <!--<div class="app-load-box clearfix js-load-box">-->
                        <!--<img src="/static/img/common/appload.png" class="l">-->
                        <!--<div class="r">-->
                        <!--<p>扫描下载APP</p>-->
                        <!--<a href="" target="_blank"><i class="icon-apple"></i>App Store下载</a>-->
                        <!--<a href="" target="_blank"><i class="icon-android"></i>Android下载</a>-->
                        <!--</div>-->
                        <!--</div>-->
                        <!--</li>-->

                        <li class="shop-cart" id="shop-cart">
                            <a href="javascript:void(0);" @click="gocart" class="shop-cart-icon">
                                <span class="icon-shopping-cart js-endcart"></span><span>购物车</span>
                                <span v-if="this.userNeme != ''" class="shopping_icon js-cart-num" data-ordernum="0"
                                      data-cartnum="0"
                                >{{cartCount}}</span>
                            </a>
                            <div class="my-cart" id="js-my-cart"></div>
                        </li>
                        <li v-if="userNeme == ''" class="header-signin">
                            <span v-text="userNeme"></span>
                            <a href="#" id="js-signin-btn" @click="showModal('login')">登录</a> / <a href="#"
                                                                                                   id="js-signup-btn"
                                                                                                   @click="showModal('register')">注册</a>
                        </li>
                        <li v-if="userNeme != ''" class="user-card-box">
                            <a class="g-user-a" href="/u/6763702" target="_self">
                                {{userNeme}}
                            </a>
                            <div class="g-user-card">
                                <div class="card-inner">
                                    <div class="card-top clearfix">
                                        <a href="/u/6763702" class="l">
                                            <img src="//img4.mukewang.com/533e4cc800016ffd02200220-100-100.jpg"
                                                 alt="weixin_ahah_0">
                                        </a>
                                        <div>
                                            <a href="">
                                                <span class="name text-ellipsis"> {{userNeme}}</span>
                                            </a>
                                        </div>
                                    </div>
                                    <el-row :gutter="20">
                                        <el-col :span="12">
                                            <el-button type="info" @click="goorder" icon="el-icon-tickets">订单中心
                                            </el-button>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-button type="info" @click="gouser" icon="el-icon-setting">个人设置
                                            </el-button>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="12">
                                            <el-button type="danger" @click="logout" icon="el-icon-setting">安全退出
                                            </el-button>
                                        </el-col>
                                    </el-row>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class='search-warp clearfix maxishidden' style='min-width: 32px; height: 72px;'>
                    <div class="pa searchTags" v-show="showtags">
                        <a @click="gosearch('职业卫生')" target="_blank">职业卫生</a>
                        <a @click="gosearch('非高危行业')" target="_blank">非高危行业</a>
                    </div>

                    <div class="search-area" data-search="top-banner" v-bind:class="{searchareabto:!showtags}">
                        <input class="search-input" @focus="isshowsearchTags()" @blur="ishidesearchTags()"
                               type="text" v-model.trim="searchdata"
                               autocomplete="off">
                        <ul class="search-area-result" v-show="rtudata.length > 0">
                            <li @click="goclass(item._id)" v-for="item in rtudata"
                                class="el-dropdown-menu__item">{{item.gzleibie}} —{{item.gzxiangmu}}
                            </li>
                        </ul>
                    </div>
                    <div @click="gosearch(searchdata)" class='showhide-search' v-bind:class="{searchcolor:!showtags}">
                        <i class='icon-search'
                           v-bind:class="{searchcolori:!showtags}"></i>
                    </div>
                </div>
            </div>

        </div>
        <login v-bind:loginShow="mdShow" v-bind:activeName="activeName" @close="closeModal"/>
    </div>
</template>

<script>
    import login from '../components/login'
    import axios from 'axios';
    import './../assets/css/header.css'

    export default {
        components: {login, axios},
        name: "Header",
        data() {
            return {
                mdShow: false,
                activeName: "login",
                showtags: true,
                searchdata: "",
                rtudata: [],
            }
        },
        computed: {
            userNeme() {
                return this.$store.state.userNeme;
            },
            cartCount() {
                return this.$store.state.cartCount;
            }
        },
        methods: {
            showModal(obj) {
                this.mdShow = true;
                this.activeName = obj;
            },
            closeModal() {
                this.mdShow = false;
            },
            //获取数据
            getLogdata() {
                axios.post("/Api/admin/getLogdata").then(res => {
                    if (res.statusText == "OK") {
                        if (res.data.errcode == 0) {
                            this.$store.commit('upUserName', res.data.data);

                        }
                    }
                });
                axios.post("/Api/admin/getStoreNumber").then(res => {
                    if (res.statusText == "OK") {
                        if (res.data.errcode == 0) {
                            this.$store.commit('upcartCount', res.data.data);
                        } else if (res.data.errcode == 40000) {
                            // this.$store.commit('upcartCount', res.data.data);
                        } else {
                            this.$store.commit('upcartCount', 0);
                        }
                    }
                });
            },
            //退出
            logout() {
                axios.post("/Api/admin/logout").then(() => {
                    this.$store.commit('upUserName', "");
                    this.$store.commit('upcartCount', 0);
                    //退出登录
                    this.$message({
                        showClose: true,
                        message: '安全退出登录！',
                        type: 'success',
                        duration: 15000
                    });
                    this.$router.push({
                        name: 'Main'
                    });
                });
            },
            //去购物车
            gocart() {
                if (this.userNeme == "") {
                    this.showModal("login");
                } else {
                    this.$router.push({
                        name: 'Cart'
                    });
                }
            },
            //去订单中心
            goorder() {

                this.$router.push({
                    name: 'Ordercenter',
                })
            },
            //去订单中心
            gouser() {
                this.$router.push({
                    name: 'User',
                })
            },
            //隐藏搜索tags
            isshowsearchTags() {
                this.showtags = false;
                if (this.searchdata != "") {
                    this.oksearch(this.searchdata);
                }
            },
            //显示搜索tags
            ishidesearchTags() {
                this.showtags = true;
                setTimeout(this.clsdata, 200);
            },
            goclass(data) {
                this.rtudata = [];
                this.$router.push({
                    name: 'Class',
                    params: {
                        id: data
                    }
                })
            },
            oksearch(val) {
                axios.post("/Api/searchdata", {val: val}).then(res => {
                    if (res.statusText == "OK") {
                        if (res.data.errcode == 0) {
                            this.rtudata = res.data.data;
                        }
                    }
                });
            },
            clsdata() {
                this.rtudata = [];
            },
            gosearch(data) {
                if (data == "") {
                    this.$router.push({
                        path: '/Search',
                    });
                } else {
                    this.$router.push({
                        path: '/Search/' + data,
                    });
                }
            },
        },
        mounted() {
            this.getLogdata();
        },
        watch: {
            searchdata(val, oldVal) {
                if (val != "") {
                    this.oksearch(val);
                } else {
                    this.rtudata = [];
                }
            },
        },
    }
</script>
